<template>
    <div class="wrapper">
        <vue-progress-bar></vue-progress-bar>

        <header-brand />

        <slot></slot>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import HeaderBrand from '@/components/AppHeader/Brand.vue'

export default {
    name: 'SubdomainBrandLayout',

    components: { HeaderBrand },

    computed: {
        ...mapGetters('user', ['isRetailer']),
    },

    created() {
        this.setCartPublicFromLocStor()
    },

    async mounted() {
        await this.getTypes({existing: true})
    },

    methods: {
        ...mapActions(['setCartPublicFromLocStor']),
        ...mapActions('types', ['getTypes'])
    }
}
</script>
